import requestor from "shared/service/requestor";

export default class StatisticsApi {
  get = (dateFrom, dateTo, periodType, search = "") =>
    requestor.get("/project/statistics", {
      search,
      filter: {
        from: dateFrom,
        to: dateTo,
        period_type: periodType,
      },
    });

  getDetails = (date, periodType, orderState) =>
    requestor.get("/project/statistics_detail", {
      date: date,
      period_type: periodType,
      order_state: orderState,
    });

  service = {
    get: (dateFrom, dateTo, periodType) =>
      requestor.get("/admin/service_statistics", {
        filter: {
          from: dateFrom,
          to: dateTo,
          period_type: periodType,
        },
      }),
  };
  sells = {
    get: (dateFrom, dateTo, periodType) =>
      requestor.get("/admin/sells_statistics", {
        filter: {
          from: dateFrom,
          to: dateTo,
          period_type: periodType,
        },
      }),
  };
  sellers = {
    get: (dateFrom, dateTo, periodType) =>
      requestor.get("/admin/sellers_statistics", {
        filter: {
          from: dateFrom,
          to: dateTo,
          period_type: periodType,
        },
      }),
    list: (dateFrom, dateTo) =>
      requestor.get("/admin/sellers_list_statistics", {
        filter: {
          from: dateFrom,
          to: dateTo,
        },
      }),
  };
}
